import React, { useState } from 'react';
import { useAppBridge } from '@shopify/app-bridge-react';
import { Card, List, Page } from '@shopify/polaris';
import { User } from './Providers/UserProvider';
import { userLoggedInFetch } from '../containers/ShopifyContainer';

type ManageSubscriptionProps = {
  user: User
}
function SubscriptionNeeded () {
  const [loading, setLoading] = useState(false);
  const shopifyHostId = new URL(location.toString()).searchParams.get('host') || '';
  const shopUrl = new URL(location.toString()).searchParams.get('shop') || '';
  const app = useAppBridge();
  const fetch = userLoggedInFetch(app);
  const createSubscription = async () => {
    setLoading(true);
    const res = await fetch('/shopify/create-subscription',
      {
        method: 'POST',
        body: JSON.stringify({ shop: shopUrl, host: shopifyHostId }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );
    const jsonRes = await res.json();
    window.parent.location.href = jsonRes.confirmationUrl;
  };
  return (
    <Card
      title='You need a subscription to use the Woorank shopify app'
      primaryFooterAction={{ content: 'Subscribe', loading, onAction: createSubscription }}
    >
      <Card.Section title='Features'>
        <List>
          <List.Item>14 day free trial</List.Item>
          <List.Item>Review up to 10 pages</List.Item>
          <List.Item>Woorank assistant</List.Item>
          <List.Item>Core Web vitals</List.Item>
        </List>
      </Card.Section>
    </Card>
  );
}

function UsersWithExistingWoorankSubscription () {
  return (
    <Card
      title='You have an existing Woorank subscription'
    >
      <Card.Section title='Contact us'>
        Contact our support team so that we can give access to the Shopify Woorank application.
      </Card.Section>
    </Card>
  );
}
export default function ManageSubscription ({ user }: ManageSubscriptionProps) {
  const userHasNonShopifyPlan = user.subscription && user.subscription.planCode !== 'shop1';
  console.log({ userHasNonShopifyPlan });
  return (
    <Page>
      {
        userHasNonShopifyPlan ? UsersWithExistingWoorankSubscription() : SubscriptionNeeded()
      }
    </Page>
  );
}
